import type { PermissionRequirement } from '~/utils/permissionRequirement'

/**
 * Accès à l'écran Suivi de projet : l'un des deux rôles de la page, lecteur ou administrateur
 * (M13, ADR 0010 du service `apps/product-management`), le même test que `hasPageAccess` côté
 * service. Le manager et les contributeurs d'une brique ne sont pas un droit Lucie : le service les
 * tient dans sa base.
 */
export const PRODUCT_MANAGEMENT_READ: PermissionRequirement = {
  any: [
    ['read', 'product-management.roles.reader'],
    ['read', 'product-management.roles.administrator'],
  ],
}
